import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import Button from "~/componentes/Button";
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: 0;

    .col {
      padding: 0.5rem;
    }
    
    .col.w1 {
      width: 5em;
    }
    .col.w2 {
      width: 10em;
    }
    .col.w3 {
      width: 15em;
    }
    .col.w4 {
      width: 20em;
    }
    .col.w5 {
      width: 25em;
    }
    .col.w6 {
      width: 30em;
    }

    .center {
      text-align: center;
    }
  }

  .content-os {
    background: ${Colors.Color13};
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    padding: 1.1rem;

    .header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4rem;
        padding: 0.15rem 0.8rem 0.15rem 0.3rem;
        width: fit-content;

        img {
          width: 1.4rem;
        }

        .title {
          font-size: 0.8125rem;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5rem;
        }
      }

      .div-right {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
        height: fit-content;

        .pagination {
          margin-left: 1rem;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: flex-end;
          height: fit-content;
        }

        .btn-excel, .btn-pdf {
          height: 1.8rem;
          width: 1.8rem;
          padding: 0rem;
          font-size: 0.88rem;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25em solid ${Colors.Color4};
          border-radius: 0.4rem;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 1rem;

          img {
            width: 1rem;
          }
        }
      }

      .div-icone {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4rem;
        padding: 0.15rem 0.8rem 0.15rem 0.3rem;
        width: fit-content;
        margin-bottom: 1.5rem;

        img {
          width: 1.4rem;
        }

        .title {
          font-size: 0.7125rem;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5rem;
        }
      }
    }

    .filtro {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 100%;
      margin-top: 0.5rem;
      margin-bottom: 1rem;

      .item {
        width: 10rem;
        margin-left: 0.6rem;

        select {
          width: 100%;
        }
      }
    }

    .body {
      height: 100% !important;

      .card-header {
        background: ${Colors.Color2};

        p {
          font-weight: 700;
          color: ${Colors?.Color4};
        }
      }
    }
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 0.7em;
  padding: 0.5em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
  position: relative;
  overflow: hidden;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color26 : Colors.Color2};
  box-shadow: none !important;

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .row {
    .col {
      p {
        font-size: 0.7rem;
        font-weight: bold;
        color: ${Colors.Color14};
        
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;

export const PageButtonNumber = styled(Button)`
  position: relative;
  background: none;
  border: none;
  font-size: 0.9em;
  padding: 0.1em 0.7em;
  margin-left: 0.25em;
  margin-right: 0.25em;

  ${(props) => {
    if (props?.ativo) {
      return `
        color: ${Colors.Color13};
      `;
    } else {
      return `
        color: ${Colors.Color13};
      `;
    }
  }}

  :hover {
    color: ${Colors.Color13};

    p {
      color: ${Colors.Color13};
    }
  }

  ${(props) => {
    if (props?.ativo) {
      return `
        span {
          position: absolute;
          content: "";
          display: block;
          background: ${Colors.Color4};
          width: 100%;
          height: 100%;
          margin-left: -0.7em;
          margin-top: -0.1em;
          border-radius: 0.5em;
          transition: 1s;
        }
      `;
    } else {
      return `
        span {
          position: absolute;
          display: none;
          content: "";
          width: 0;
          height: 0;
          transition: 1s;
        }

        p {
          color: ${Colors.Color14};
        }
      `;
    }
  }}

  :hover span {
    display: block;
    background: ${Colors.Color4};
    width: 100%;
    height: 100%;
    margin-left: -0.7em;
    margin-top: -0.1em;
    border-radius: 0.5em;
  }

  p {
    position: relative;
  }
`;

export const PageButtonIcon = styled(Button)`
  background: ${Colors.Color1};
  width: 1.3em;
  height: 1.3em;
  border-radius: 0.3em;
  border: none;
  color: ${Colors.Color4};
  font-size: 0.8em !important;
  margin-left: 0.25em;
  margin-right: 0.25em;

  :hover {
    background: ${Colors.Color4};
    color: ${Colors.Color13};
  }
`;
